// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"3e40e9f7","654":"e6d384d0","787":"7f5d0b19"}[chunkId] + ".chunk.js";
};